import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  handleLogoutRedirect,
  handleFirstLoginAfterSignUp,
  handleSecurityQuestionRedirect,
  jsonApiHeader,
  showSuccessMessage,
  handleLoginRedirect,
} from '.././../../../actions/utilAction';
import { API_URL } from '../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  handleFirstLoginAfterSignUp,
  handleSecurityQuestionRedirect,
  handleLogoutRedirect,
  handleLoginRedirect,
};

export const BUSINESS_NAME_API = `${API_URL}/VerifyBusinessName`;
export const LOGIN_API = `${API_URL}/Login/PatientLogin`;
//export const LOGOUT_API = `${API_URL}/authentication/logout`;
export const LOGOUT_API = `${API_URL}/Login/Logout`;
export const FORGOT_PASSWORD_API = `${API_URL}/ForgotPassword`;
export const REFRESH_TOKEN = `${API_URL}/GetUserByToken`;
export const RESET_PASSWORD_API = `${API_URL}/ResetPassword`;

export const loginActionTypes = {
  check_business_name: createRequestActionTypes('CHECK_BUSINESS_NAME'),
  post_login: createRequestActionTypes('POST_LOGIN'),
  post_forgotPassword: createRequestActionTypes('POST_FOTGOT_PASSWORD'),
  logout_user: createRequestActionTypes('LOGOUT_USER'),
  refresh_token: createRequestActionTypes('REFRESH_TOKEN'),
  post_resetPassword: createRequestActionTypes('POST_RESET_PASSWORD'),
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/logins/constants/ApiConstants.js